import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Select, Store } from '@ngxs/store';
import { AccountActions, AccountSelectors, AuthorizationActions, AuthorizationSelectors, CoreSelectors, ModulesSelectors, NavigationActions, NavigationSelectors, SosLoaderService } from '@serviceos-ng/core';
import { Observable, Subscription } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';

@Component({
    selector: 'serviceos-web-create-account-screen',
    templateUrl: './create-account-screen.component.html',
    styleUrls: ['./create-account-screen.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class CreateAccountScreenComponent implements OnInit {

    @Select(ModulesSelectors.getImageFromModule('auth', 'auth_page_background'))
    authPageBackground$!: Observable<string>;

    @Select(ModulesSelectors.getComponentFromModule('auth', 'slider'))
    sliderData$!: Observable<any>;

    private subscriptions: Subscription[] = [];

    public isCoreInit = false;
    public isUserAuthorized = true;
    public screen = 'create-account';
    public view = ''; // register - normal register form, merge - all register data is prefill, the user add only password
    public mergeAccountData = null;
    public referralCode = null;

    constructor(
      private router: Router,
      private route: ActivatedRoute,
      private store: Store,
      private _loaderService: SosLoaderService
      ) {}

    ngOnInit(): void {
        
        const loader = this._loaderService.showLoader();

        const initRouteData = this.store.selectSnapshot(NavigationSelectors.getInitRoute);

        if (initRouteData?.data?.token || initRouteData?.data?.['fs_payload[merge_token]']) {

            const token = initRouteData?.data?.token ? initRouteData.data.token : initRouteData.data['fs_payload[merge_token]'];

            const fetchLoader = this._loaderService.showLoader();

            this.store
                .dispatch(new AuthorizationActions.mergeAccount(token))
                .pipe(
                    finalize(() => {
                        
                        this.subscriptions.push(this.store.select(AuthorizationSelectors.getMergeAccount)
                            .subscribe(
                                (data) => {
                                    this.mergeAccountData = data;
                                }
                            ));
                    })
                )
                .subscribe(
                    (res) => {
                        this.view = 'merge';
                        this._loaderService.hideLoader(fetchLoader);
                    },
                    (err) => {
                        this.view = 'register';
                        this._loaderService.hideLoader(fetchLoader);
                    }
                );

        } else {
            this.view = 'register';
        }


        this.subscriptions.push(this.route.params.subscribe(
            (params) => {
                if (params?.id) {
                    this.referralCode = params.id;
                }
            }
        ));

        this.subscriptions.push(this.store.select(CoreSelectors.completeInitialize)
            .subscribe(
                (result) => {
                    this.isCoreInit = !!result;
                    this._loaderService.hideLoader(loader);
                }
            ));

        const authLoader = this._loaderService.showLoader();
        this.subscriptions.push(this.store
            .select(AuthorizationSelectors.getAuthorization)
            .subscribe((data) => {
                if (data) {
                    if (data.sid) {
                        this._loaderService.hideLoader(authLoader);
                        this.router.navigate(['']);
                    } else {
                        setTimeout(()=> {
                            this._loaderService.hideLoader(authLoader);
                            this.isUserAuthorized = false;
                        }, 1500); // BUG - add delay for components to render because of missing sid on init (later on its read it from cookie and will create sid in state/store)
                    }

                    // const sid = this.cryptoService.encryptData(data, this.env.cookieKey);
                    window.parent.postMessage(
                        { event: 'authorization', sid: data.sid },
                        '*'
                    );
                }
            }));
    }

    ngOnDestroy(): void {
        this.subscriptions.map((el) => el.unsubscribe());
    }

    public onChangeScreen(screen) {

        this.store
                    .dispatch(new NavigationActions.ClearRouteConfig())
                    .subscribe();
        
        this.router.navigate(['/auth/' + screen], { relativeTo: this.route });
    }
}
